module.exports = __webpack_public_path__ + "img/mob.44b12593.svg";